var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchOutlinedGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_353",
    "data-name": "Rectangle 353",
    width: 17.49,
    height: 17.49,
    transform: "translate(0 0)",
    fill: "#333"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#334856",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1903",
    "data-name": "Groupe 1903",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1902",
    "data-name": "Groupe 1902",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_620",
    "data-name": "Trac\\xE9 620",
    d: "M12.5,11h-.79l-.28-.27a6.51,6.51,0,1,0-.7.7l.27.28v.79l5,4.99L17.49,16Zm-6,0A4.5,4.5,0,1,1,11,6.5,4.494,4.494,0,0,1,6.5,11",
    fill: "#959FB2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchOutlinedGrey);
export default __webpack_public_path__ + "static/media/SearchOutlinedGrey.2c15935fe14577082bef215deb05fb32.svg";
export { ForwardRef as ReactComponent };